import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { NGXLogger } from 'ngx-logger';
import { Observable } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import {
  Role,
  RoleCreate,
  RolePagedList,
  RolesSearchBody
} from 'src/swagger-gen/web-secured/models';
import { BaseService } from '../services/base.service';

@Injectable({
  providedIn: 'root',
})
export class AdministrationRepo extends BaseService {
  administrationUrl = environment.apiUrl + '/administration' ;
  customAdministrationUrl = environment.apiUrl + '/custom' ;
  readonly LIMIT = '20';

  constructor(private http: HttpClient, private logger: NGXLogger) {
    super();
  }

  /**
   * Get all roles
   */
  searchRoleList(offset: number, limit: number, params: any[], body: RolesSearchBody): Observable<RolePagedList> {
    const url = this.administrationUrl + '/roles/search';
    let requestString = this.pagination(offset, limit, this.LIMIT);
    let queryParams = '';
    params.forEach((p: any) => {
      queryParams += '&' + p.key + '=' + p.value;
    });
    requestString += queryParams;
    const requestParams = new HttpParams({ fromString: requestString });
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
      params: requestParams,
    };

    return this.http.post<RolePagedList>(url, body, httpOptions).pipe(
      catchError(this.handleServerError)
    );
  }

  /**
 * Get station by uid
 * @param uid - station uid
 */
    getRole(uid: string): Observable<Role> {
    const url = this.administrationUrl + '/roles/' + uid;
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };

    return this.http.get<Role>(url, httpOptions).pipe(
      catchError(this.handleServerError)
    );
  }

  createRole(roleCreate: RoleCreate): Observable<any> {
    const url = this.administrationUrl + '/roles';

    const httpOptions = {
      headers: this.httpHeaders(),
      observe: 'response' as 'body',
    };

    return this.http.post<any>(url, roleCreate, httpOptions).pipe(
      tap((response) => {
        this.logger.log(`New station created`, response);
      }), // DEBUG
      catchError(this.handleServerError)
    );
  }

  updateRole(roleUid: string, roleUpdate: any): Observable<any> {
    const url = this.administrationUrl + '/roles/' + roleUid;

    const httpOptions = {
      headers: this.httpHeaders(),
      observe: 'response' as 'body',
    };

    return this.http.put<void>(url, roleUpdate, httpOptions).pipe(
      tap((response) => {
        this.logger.log(
          `Role with uid:` + roleUid + ' updated',
          response
        );
      }), // DEBUG
      catchError(this.handleServerError)
    );
  }

  deleteRole(uid: string) {
    const url = this.administrationUrl + '/roles/' + uid;

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      })
    };

    return this.http.delete<any>(url, httpOptions).pipe(
      catchError(this.handleServerError)
    );
  }
}
